import styled from 'styled-components';

export const AssetValuationContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ValuationPricesModule = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  column-gap: 20px;
`;

// export const ValuationModulesContainer = StyleSheet.create({
//   marketValues: {
//     width: "100%",
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     columnGap: 30,
//     border: "1px solid yellow",
//   },
// });
